import dynamic from 'next/dynamic'
import { useSkinnyCmExperiment } from '../hooks/useSkinnyCmExperiment'

const SkinnyCmModal = dynamic(() => import('./SkinnyCmModal'), { ssr: false })

/**
 * Mounted on the CM page inside StaticDataProvider. Renders the modal only for
 * bucketed, logged-out users on eligible slugs — control users never load the
 * modal bundle.
 */
export const SkinnyCmModalGate = () => {
  const { shouldShow, slug } = useSkinnyCmExperiment()
  if (!shouldShow) return null
  // Remount the modal on slug change so a soft navigation to another eligible
  // class (e.g. tapping a Screen 3 recommended card) restarts the flow from
  // Screen 1 instead of leaving the previous class's modal open on Screen 3.
  return <SkinnyCmModal key={slug} />
}
